import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { ReportService } from '@src/domain/services';


interface CarRecordsDto extends ReportService.GetCarRecordsRespBo {}

interface CarInfosDto extends ReportService.GetCarInfosRespBo {}

interface PIORecordsDto extends ReportService.GetPIORecordsRepsBo {}

interface EmployeeRecordsDto extends ReportService.GetEmployeeRecordsRespBo {}

interface CarStatisticsDto extends ReportService.GetCarStatisticsRespBo {}

export type ItemListDto = CarRecordsDto | CarInfosDto | PIORecordsDto | EmployeeRecordsDto | CarStatisticsDto | null;

export interface ReportState {
  itemListData: ItemListDto
}

/** 設定 */
export const reportSlice = createSlice({
  name: 'report',
  initialState: {
    /** 設定清單資料 */
    itemListData: null
  } as ReportState,
  reducers: {
    setItemList(state, action: PayloadAction<ItemListDto>) {
      state.itemListData = action.payload
    },
    clearItemList(state) {
      state.itemListData = null
    }
  },
});

export const reportReducer = reportSlice.reducer
export const reportActions = reportSlice.actions
